/** @format */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { invokeApi } from "../../utils/http-service";
import { HOSTNAME } from "../../../common-utilities/utils/end-points";
import { REST_URLS } from "../../../common-utilities/utils/end-points/tech-net";
import "./index.scss";
import {
  convertToCamelCaseFromUnderScore,
  formatDate,
} from "../../../common-utilities/utils";
import TimeLine from "../../../common-utilities/core/time-line";
import { DATE_FORMATS } from "../../../common-utilities/utils/constants";
import { HTTP_METHODS } from "../../../common-utilities/utils/http-service";

const StatusTimeLine = () => {
  const { id } = useParams();
  const [statusHistory, setStatusHistory] = useState([]);

  useEffect(() => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.TICKET_STATUS_HISTORY}/${id}`
    )
      .then((response) => {
        if (response?.length > 0) {
          setStatusHistory(response);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className="time-line-info-container">
      <div className="time-line">
        {statusHistory?.map((h, index) => {
          return (
            <TimeLine
              displayLine={index !== statusHistory.length - 1}
              key={h.id}
            >
              <span className="line1">{h?.timeInDays}</span>
              <span style={{ color: "gray" }}>
                {" "}
                - {"  On "}
                {formatDate(h.createdAt, DATE_FORMATS["DD/MM/YYYY hh:MM"])}
              </span>
              <div className="line-1">
                {convertToCamelCaseFromUnderScore(h?.startingStatus)} to{" "}
                {convertToCamelCaseFromUnderScore(h.endingStatus)}
              </div>
            </TimeLine>
          );
        })}
      </div>
    </div>
  );
};

export default StatusTimeLine;
